module.exports = __webpack_public_path__ + "img/79800.6c17464e.jpg";